import { type SerializedCompStructure } from '@wix/document-services-types'

import { type CheckboxInputData } from '../types'

export function assertCheckboxInputData(
  data: NonNullable<SerializedCompStructure['data']>,
): asserts data is CheckboxInputData {
  const TYPE: CheckboxInputData['type'] = 'CheckboxInput'
  if (data.type !== TYPE) {
    throw new Error('Not checkbox-input data.')
  }
}
